import { Button } from '@octopus-do/octopus-storybook'
import { MagnifyingGlass, Times } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'
import { useSearch } from './useSearch'

interface Props {
  onChange: (value: string) => void
  value: string
}

export const SearchPages: React.FC<Props> = ({ onChange, value }) => {
  const {
    searchRef,
    inputRef,
    showInput,
    inputValue,
    handleOnChange,
    handleCloseClick,
    handleButtonClick,
  } = useSearch(onChange, value)

  return (
    <div className={css.search_pages} ref={searchRef}>
      {showInput && (
        <div className={css.input_wrap}>
          <input
            ref={inputRef}
            type="text"
            name="search"
            className={css.input}
            value={inputValue}
            placeholder="Search..."
            onChange={handleOnChange}
          />
          <button className={css.close_btn} onClick={handleCloseClick}>
            <Times />
          </button>
        </div>
      )}

      {!showInput && (
        <div className={css.button_wrap}>
          <Button
            priority="secondary"
            size="medium"
            left={MagnifyingGlass}
            aria-label="Search pages"
            onClick={handleButtonClick}
          />
        </div>
      )}
    </div>
  )
}
